<mat-form-field [appearance]="options?.appearance? options.appearance : 'standard'">
    <mat-label>{{options.title}}<span class="asterisk"
            *ngIf="utils.isRequiredField(formControlSatelliteLockType)">*</span></mat-label>
    <input (keyup)="changeValue()" matInput [matAutocomplete]="autocompleteSatelliteLockTypes"
        [formControl]="formControlSatelliteLockType">
    <div matSuffix class="spinner-border text-info" role="status" *ngIf="loadingSatelliteLockTypes">
        <span class="sr-only">Loading...</span>
    </div>
    <mat-autocomplete #autocompleteSatelliteLockTypes="matAutocomplete" [displayWith]="displaySatelliteLockTypeName"
        (optionSelected)="onSelectSatelliteLockType($event)">
        <mat-option *ngFor="let satelliteLockType of satelliteLockTypesFiltered" [value]="satelliteLockType">
            <span>{{satelliteLockType.name}}</span>
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="formControlSatelliteLockType.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
</mat-form-field>
